module.exports = __webpack_public_path__ + "static/media/talanx.a785f597.svg";